import { useRubrics } from 'src/hooks/news';

import { Dialog, Typography, Grid, Sheet, Divider, Button, Icon } from '@sravni/react-design-system';
import { Cross } from '@sravni/react-icons';
import { useIsPhone } from '@sravni/react-utils';

import { RubricMenuSearch } from '../../../SearchBlock';
import { FormatsMenu } from '../CustomDialogRubricMenu/components/FormatsMenu';

import { Item } from './components/Item';
import styles from './dialogrubricmenu.module.scss';

interface Props {
  view: boolean;
  closeView: () => void;
  subscriptionPopupState: [number, (value: number) => void];
}

export const DialogRubricMenu = ({ view, closeView, subscriptionPopupState }: Props) => {
  const isMobile = useIsPhone();
  const headingMenu = isMobile ? 'Журнал' : 'Все рубрики';

  const rubrics = useRubrics();

  return isMobile ? (
    <Sheet className={styles.sheet} visible={view} closable={false} fullscreen onClose={closeView}>
      <Sheet.Content className={styles.sheetContent}>
        <Typography.Text size={16} strong className="h-mb-12">
          {headingMenu}
        </Typography.Text>
        <FormatsMenu subscriptionPopupState={subscriptionPopupState} hideMenuController={closeView} />
        <Divider className="h-mt-8 h-mb-8" />
        <Typography.Text size={16} strong className="h-mb-12 h-mt-12">
          Рубрики
        </Typography.Text>
        <Grid.Row gutter={[20, 20]} className={styles.row}>
          {rubrics?.map((item) => (
            <Item item={item} closeView={closeView} />
          ))}
        </Grid.Row>
      </Sheet.Content>
      <Sheet.Footer className={styles.bottomMenu}>
        <div className={styles.searchAndBtnCloneBlock}>
          <div>
            <Button onClick={closeView} className={styles.closeButton} size={52} color="blue" variant="outlined">
              <Icon icon={<Cross />} />
            </Button>
          </div>
          <RubricMenuSearch toogleRubricMenu={closeView} />
        </div>
      </Sheet.Footer>
    </Sheet>
  ) : (
    <Dialog className={styles.dialog} visible={view} onClose={closeView}>
      <Dialog.Header>
        <Typography.Heading level={3} className={styles.heading}>
          {headingMenu}
        </Typography.Heading>
      </Dialog.Header>
      <Dialog.Content>
        <Grid.Row gutter={[20, 20]} className={styles.row}>
          {rubrics?.map((item) => (
            <Item item={item} closeView={closeView} />
          ))}
        </Grid.Row>
      </Dialog.Content>
    </Dialog>
  );
};
